import { EmptyState } from '@airship-platform/jam-web/components';
import Typography from '@mui/material/Typography';

interface SowQueryEmptyStateProps {
  searchTerm: string;
  isVisible: boolean;
}

const SowQueryEmptyState: React.FC<SowQueryEmptyStateProps> = ({
  searchTerm,
  isVisible,
}) =>
  isVisible ? (
    searchTerm ? (
      <EmptyState
        title="No statements of work found"
        subtitle={
          <Typography variant="body2" component={'div'}>
            No results found for search term{' '}
            <Typography variant="subtitle2">{searchTerm}</Typography>
          </Typography>
        }
      />
    ) : (
      <EmptyState
        title="No statements of work available"
        subtitle={
          <Typography variant="body2" component={'div'}>
            Statement of Work have not been added by your manager or admin yet.
            Once they are set up, you will be able to insert them into your
            proposals.
          </Typography>
        }
      />
    )
  ) : null;

export default SowQueryEmptyState;
